import type { JSX } from 'react'

export const LogOutIcon = (): JSX.Element => (
  <use href='#logOutIcon' height='100%' width='100%' />
)
